import React, { useState } from "react";
import { Modal } from "antd";
import ReactPlayer from "react-player";
import styles from "./FloatingAbout.module.css";
import aboutImg from "../../../Assets/aboutus.png";

const FloatingAbout = () => {
    const [isModalVisible, setIsModalVisible] = useState(false);

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    return (
        <>
            <div className={styles.floatingContainer} onClick={showModal}>
                <div className={styles.imageWrapper}>
                    <img src={aboutImg} alt="About Us" className={styles.aboutImage} />
                </div>
                <div className={styles.textWrapper}>
                    <p className={styles.aboutText}>What to know about us?</p>
                </div>
            </div>

            <Modal
                title="About Us"
                open={isModalVisible}
                onCancel={handleCancel}
                footer={null}
                width={800}
                centered
                destroyOnClose
            >
                <div className={styles.videoPlayerWrapper}>
                    <ReactPlayer
                        url="https://youtu.be/aLlYyYLmp-Q"
                        playing={isModalVisible}
                        controls
                        width="100%"
                        height="100%"
                    />
                </div>
            </Modal>
        </>
    );
};

export default FloatingAbout;
